<div class="audit-mixin">
  <!-- Top Rows -->
  @if (showSingle) {
    @if (showTitle) {
      <div class="row" style="margin-bottom:6px;">
        {{model.auditItemId | getName:model.type | async}}
      </div>
    }
    <div class="row">
      <div>Created on:</div>
      <div>{{model.attributes?.created_on | stringDate}}</div>
    </div>
    <div class="row">
      <div>Created by:</div>
      <div>
        {{model.attributes?.created_by_name}} {{model.attributes?.created_by_lastname !== null ? model.attributes?.created_by_lastname : ""}}
      </div>
    </div>
    <div class="row" style="margin-top:6px;">
      <div>Changed on:</div>
      <div>{{model.attributes?.changed_on | stringDate}}</div>
    </div>
    <div class="row">
      <div>Changed by:</div>
      <div>
        {{model.attributes?.changed_by_name}} {{model.attributes?.changed_by_lastname !== null ? model.attributes?.changed_by_lastname : ""}}
      </div>
    </div>
  }

  <!--  &lt;!&ndash; Expand/Collapse Toggle &ndash;&gt;-->
  <!--  @if (model.auditItemId) {-->
  <!--  <div class="toggle-arrow" style="text-align: center;" (click)="toggleAudit()">-->
  <!--    <span class="material-symbols-outlined">-->
  <!--      {{isAuditExpanded ? 'arrow_drop_up' : 'arrow_drop_down'}}-->
<!--    </span>-->
<!--  </div>-->
<!--  }-->

<!-- Audit Table -->
@if (!showSingle) {
  <div class="audit-table">
    <linked-component-audit-table [model]="model"></linked-component-audit-table>
  </div>
}
</div>
